import { debounce, throttle } from 'lodash';
export function sendTiming(name, timing, category, label) {
  try {
    window.gtag('event', 'timing_complete', {
      name: name,
      value: timing,
      event_category: category,
      event_label: label,
    })
  } catch (e) {
    console.log(e)
  }
}

export function sendRequest(action, label) {
  try {
    window.gtag('event', action, {
      event_category: 'Usage Frequency',
      event_label: label,
      value: 1,
    })
  } catch (e) {
    console.log(e)
  }
}

export function windowOpen(url, pure_url, type) {
  sendRequest('Request - ' + location.host, pure_url)
  window.open(url, type)
}

// 防抖
export function _debounce(fn, delay) {
 
  var delayTime = delay || 200;
  var timer;
  return function () {
      var th = this;
      var args = arguments;
      if (timer) {
          clearTimeout(timer);
      }
      timer = setTimeout(function () {
          timer = null;
          fn.apply(th, args);
      }, delayTime);
  };
}
// 节流
export function _throttle(fn, interval) {
  var last;
  var timer;
  var intervalTime = interval || 200;
  return function () {
      var th = this;
      var args = arguments;
      var now = +new Date();
      if (last && now - last < intervalTime) {
          clearTimeout(timer);
          timer = setTimeout(function () {
              last = now;
              fn.apply(th, args);
          }, intervalTime);
      } else {
          last = now;
          fn.apply(th, args);
      }
  }
}


// 防抖
export function debounceFn(fn, delay = 200, options = { leading: true, trailing: false }) {
  const debouncedFunc = debounce(fn, delay, options);  
  // 返回一个包装器函数，该函数接受额外的参数并调用debounced函数  
  return debouncedFunc;  
}

// 节流
export function throttleFn(fn, delay = 200, options = { leading: true, trailing: false }) {
  const throttleFunc = throttle(fn, delay, options);  
  // 返回一个包装器函数，该函数接受额外的参数并调用debounced函数  
  return throttleFunc;  
}